import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LoadStatus } from '../../../model';
import {
    HealthInfo,
    ServiceHealthStatus,
    ServicesHealthInfo,
} from '../../../model/HealthInfo';
import { fetchHealthInfo } from './healthDashboardApi';
import { createAppThunk } from '../../thunks';

export type FeatureServiceKey = keyof ServicesHealthInfo;

export interface FeatureService {
    id: string;
    label: string;
    status: ServiceHealthStatus;
}

export interface HealthDashboardState {
    loadStatus: LoadStatus;
    healthInfo?: HealthInfo;
    services?: Record<FeatureServiceKey, FeatureService>;
}

const initialState: HealthDashboardState = {
    loadStatus: 'loading',
};

export const loadHealthInfo = createAppThunk<HealthInfo>(
    'healthDashboard/loadHealthInfo',
    async () => {
        var response = await fetchHealthInfo();
        return response.data;
    }
);

export const healthDashboardSlice = createSlice({
    name: 'healthDashboard',
    initialState,
    reducers: {
        setServiceStatuses: (
            state: HealthDashboardState,
            action: PayloadAction<Record<FeatureServiceKey, FeatureService>>
        ) => {
            state.services = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadHealthInfo.pending, (state) => {
                state.loadStatus = 'loading';
            })
            .addCase(loadHealthInfo.fulfilled, (state, action) => {
                state.loadStatus = 'idle';
                state.healthInfo = action.payload;
            })
            .addCase(loadHealthInfo.rejected, (state) => {
                state.loadStatus = 'failed';
            });
    },
});

export const { setServiceStatuses } = healthDashboardSlice.actions;

export default healthDashboardSlice.reducer;
